import React, { forwardRef } from "react";

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
}

// NextJS Icon
export const NextjsIcon = forwardRef<SVGSVGElement, IconProps>(
  ({ className, size, width, height, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 180 180"
      width={width ?? size ?? "1.5em"}
      height={height ?? size ?? "1.5em"}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="90" cy="90" r="90" fill="currentColor" />
      <path
        d="M149.508 157.52L69.142 54H54v72h13.5v-52.628l68.324 88.08c4.664-4.248 8.892-9.04 12.684-14.28zM126 54h-13.5v72H126V54z"
        fill="white"
      />
    </svg>
  )
);
NextjsIcon.displayName = "NextjsIcon";

// TypeScript Icon
export const TypescriptIcon = forwardRef<SVGSVGElement, IconProps>(
  ({ className, size, width, height, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 100 100"
      width={width ?? size ?? "1.5em"}
      height={height ?? size ?? "1.5em"}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="100" height="100" rx="12" fill="#3178C6" />
      <path
        d="M68.5 75.3c-.9 1.6-2.2 2.9-4 3.7-1.8.8-4 .1-6.5-2.1-2.5-2.2-4.5-5.5-6-9.9l6-3.5c1.1 2.9 2.4 5.1 3.9 6.6s3 .2 4.4-.6c1.4-.8 2.1-2 2.1-3.6 0-1.4-.6-2.6-1.8-3.6-1.2-1-3.1-2-5.7-3.1-3.3-1.4-5.9-3.2-7.8-5.3-1.9-2.1-2.9-4.8-2.9-8.1 0-3 1-5.6 3.1-7.8s4.9-3.3 8.4-3.3c3 0 5.6.8 7.8 2.4s3.7 4 4.5 7.1l-6 2.8c-.6-2-1.6-3.5-3-4.5s-3.1-1.5-5.1-1.5c-1.8 0-3.2.5-4.2 1.5s-1.5 2.2-1.5 3.7c0 1.2.5 2.2 1.5 3.1 1 .9 2.5 1.7 4.5 2.5 3.3 1.3 5.9 2.9 7.8 4.8 1.9 1.9 2.9 4.3 2.9 7.3.1 3.3-.9 6-2.8 8.1zm-31.9-.9c-1.8 1.6-4.1 2.4-6.9 2.4-2.8 0-5.1-.8-6.9-2.4-1.8-1.6-2.7-4-2.7-7.2V44.4H14v-6.6h6.1V26.2h7.2v11.6h9.1v6.6h-9.1v22.8c0 1.3.3 2.3.9 2.9s1.4.9 2.4.9c1 0 1.8-.3 2.4-.9.6-.6.9-1.6.9-2.9v-2.3h6.6V67c0 3.3-.9 5.8-2.7 7.4z"
        fill="white"
      />
    </svg>
  )
);
TypescriptIcon.displayName = "TypescriptIcon";

// Tailwind CSS Icon
export const TailwindcssIcon = forwardRef<SVGSVGElement, IconProps>(
  ({ className, size, width, height, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 100 100"
      width={width ?? size ?? "1.5em"}
      height={height ?? size ?? "1.5em"}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M50 25c-8.33 0-14.58 4.17-18.75 12.5C37.5 37.5 41.67 35.42 43.75 31.25c2.08-4.17 5.21-6.25 9.38-6.25 8.33 0 14.58 4.17 18.75 12.5-6.25 0-10.42 2.08-12.5 6.25-2.08 4.17-5.21 6.25-9.38 6.25zm-25 25C16.67 50 10.42 54.17 6.25 62.5 12.5 62.5 16.67 60.42 18.75 56.25c2.08-4.17 5.21-6.25 9.38-6.25 8.33 0 14.58 4.17 18.75 12.5-6.25 0-10.42 2.08-12.5 6.25-2.08 4.17-5.21 6.25-9.38 6.25z"
        fill="#38BDF8"
      />
    </svg>
  )
);
TailwindcssIcon.displayName = "TailwindcssIcon";

// Framer Motion Icon
export const FramerIcon = forwardRef<SVGSVGElement, IconProps>(
  ({ className, size, width, height, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 100 100"
      width={width ?? size ?? "1.5em"}
      height={height ?? size ?? "1.5em"}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0 0h100v50H50L0 100V50h50L0 0z" fill="currentColor" />
    </svg>
  )
);
FramerIcon.displayName = "FramerIcon";

// Firebase Icon
export const FirebaseIcon = forwardRef<SVGSVGElement, IconProps>(
  ({ className, size, width, height, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 100 100"
      width={width ?? size ?? "1.5em"}
      height={height ?? size ?? "1.5em"}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M16.2 78.3l1.1-1.4 39.4-40.4L45.4 14.8c-.8-1.5-3-1.5-3.8 0L16.2 78.3z" fill="#FFC229" />
      <path d="M83.8 78.3L72.2 55.4l-11.6-23L49 53l34.8 25.3z" fill="#FFA712" />
      <path d="M16.2 78.3l32.8 19.3c1 .6 2.2.6 3.2 0L83.8 78.3L50.6 51.5 16.2 78.3z" fill="#D83B01" />
    </svg>
  )
);
FirebaseIcon.displayName = "FirebaseIcon";

// Zustand Icon
export const ZustandIcon = forwardRef<SVGSVGElement, IconProps>(
  ({ className, size, width, height, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 100 100"
      width={width ?? size ?? "1.5em"}
      height={height ?? size ?? "1.5em"}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="100" height="100" rx="20" fill="#4338CA" />
      <circle cx="35" cy="40" r="10" fill="#FBBF24" />
      <circle cx="65" cy="40" r="10" fill="#FBBF24" />
      <path d="M30 65c10 8 30 8 40 0" stroke="#FBBF24" strokeWidth="6" strokeLinecap="round" />
    </svg>
  )
);
ZustandIcon.displayName = "ZustandIcon";

// Zod Icon
export const ZodIcon = forwardRef<SVGSVGElement, IconProps>(
  ({ className, size, width, height, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 100 100"
      width={width ?? size ?? "1.5em"}
      height={height ?? size ?? "1.5em"}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="100" height="100" rx="20" fill="#3B82F6" />
      <path d="M30 50l15 15 25-30" stroke="white" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
);
ZodIcon.displayName = "ZodIcon";

// Node.js Icon
export const NodejsIcon = forwardRef<SVGSVGElement, IconProps>(
  ({ className, size, width, height, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 100 100"
      width={width ?? size ?? "1.5em"}
      height={height ?? size ?? "1.5em"}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M50 10L18 28.5v37L50 84l32-18.5v-37L50 10zm0 12.8l20.8 12v24l-20.8 12.1-20.8-12.1v-24l20.8-12z"
        fill="#339933"
      />
    </svg>
  )
);
NodejsIcon.displayName = "NodejsIcon";

// Axios Icon
export const AxiosIcon = forwardRef<SVGSVGElement, IconProps>(
  ({ className, size, width, height, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 100 100"
      width={width ?? size ?? "1.5em"}
      height={height ?? size ?? "1.5em"}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="100" height="100" rx="20" fill="#5A29E4" />
      <path d="M25 50h50M60 35l15 15-15 15" stroke="white" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
);
AxiosIcon.displayName = "AxiosIcon";

// Imagekit Icon
export const ImagekitioIcon = forwardRef<SVGSVGElement, IconProps>(
  ({ className, size, width, height, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 100 100"
      width={width ?? size ?? "1.5em"}
      height={height ?? size ?? "1.5em"}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="100" height="100" rx="20" fill="#005BFF" />
      <path d="M30 70l20-30 20 30" stroke="white" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="50" cy="30" r="8" fill="white" />
    </svg>
  )
);
ImagekitioIcon.displayName = "ImagekitioIcon";

// Tiptap Icon
export const TiptapIcon = forwardRef<SVGSVGElement, IconProps>(
  ({ className, size, width, height, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 100 100"
      width={width ?? size ?? "1.5em"}
      height={height ?? size ?? "1.5em"}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="100" height="100" rx="20" fill="#000000" />
      <path d="M30 35h40M50 35v35" stroke="#00F0FF" strokeWidth="8" strokeLinecap="round" />
    </svg>
  )
);
TiptapIcon.displayName = "TiptapIcon";

// Razorpay Icon
export const RazorpayIcon = forwardRef<SVGSVGElement, IconProps>(
  ({ className, size, width, height, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 100 100"
      width={width ?? size ?? "1.5em"}
      height={height ?? size ?? "1.5em"}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M20 80l45-60H30L20 80z" fill="#0b72e7" />
      <path d="M45 80l35-46H55l-10 46z" fill="#00a3ff" />
    </svg>
  )
);
RazorpayIcon.displayName = "RazorpayIcon";

// Google Genkit / Gemini Icon
export const GeminiIcon = forwardRef<SVGSVGElement, IconProps>(
  ({ className, size, width, height, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 100 100"
      width={width ?? size ?? "1.5em"}
      height={height ?? size ?? "1.5em"}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M50 15c0 19.3 15.7 35 35 35-19.3 0-35 15.7-35 35 0-19.3-15.7-35-35-35 19.3 0 35-15.7 35-35z"
        fill="url(#geminiGrad)"
      />
      <defs>
        <linearGradient id="geminiGrad" x1="15" y1="15" x2="85" y2="85" gradientUnits="userSpaceOnUse">
          <stop stopColor="#9333EA" />
          <stop offset="0.5" stopColor="#3B82F6" />
          <stop offset="1" stopColor="#EC4899" />
        </linearGradient>
      </defs>
    </svg>
  )
);
GeminiIcon.displayName = "GeminiIcon";

export const GoogleIcon = GeminiIcon;
